import { Box } from '@chakra-ui/react'
import type { InsuranceInfoFooterProps } from '.'

export const InsuranceInfoFooter = ({ children, sx, ...rest }: InsuranceInfoFooterProps) => {
  return (
    <Box
      {...rest}
      sx={{
        display: { base: 'grid', md: 'flex' },
        rowGap: { base: 4, lg: 0 },
        alignItems: 'center',
        justifyContent: 'space-between',
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}
